import { gql } from "@apollo/client";

export default gql`
  query getUserAssessmentDeliveries($targetId: Int!) {
    assessmentDeliveries(targetId: $targetId) {
      edges {
        node {
          id
          complianceProgram {
            id
            title
            startDate
            dueDate
          }
        }
      }
    }
  }
`;
